<div [loading]="loading()">
	@if(favoris().length){
		<!-- <div>
			<div class="carousel carousel-center w-full space-x-4">
			  <div class="carousel-item">
			  	<lgb-hero-binder [uBinder]="null" [binder]="null" route="collect-binder" [routeParams]="['1234']"></lgb-hero-binder>
			  </div>
			  <div class="carousel-item">
				<a href="#" [routerLink]="router.parse('collect-card', ['1234'])" class="w-80">
					<img hSkeleton="250px" src="https://img.daisyui.com/images/stock/card-1.webp?x"/>
				</a>
			  </div>
			  <div class="carousel-item">
			  	<lgb-hero-binder [uBinder]="null" [binder]="null" route="collect-binder" [routeParams]="['1234']"></lgb-hero-binder>
			  </div>
			  <div class="carousel-item">
				<a href="#" [routerLink]="router.parse('collect-card', ['1234'])" class="w-80">
					<img hSkeleton="250px" src="https://img.daisyui.com/images/stock/card-1.webp?x"/>
				</a>
			  </div>
			</div>
		</div> -->
		<div class="options-container mb-4">
			<div class="view-switch">
				<!-- <i class="fa-solid fa-grip-lines-vertical"></i> -->
				<i class="fa-sharp fa-light fa-objects-column"></i>
				<input [ngModel]="settings.options().favorisInfo" (ngModelChange)="settings.toggle('favorisInfo')" type="checkbox" class="ml-2 toggle toggle-primary" />
			</div>

		</div>

		<!-- vue carouselle -->
		@if(!settings.options().favorisInfo){
			<div>
				<div class="carousel carousel-center w-full space-x-4">
				  @for(item of favoris(); track item; let i=$index){
					  <div class="element-show carousel-item" [style.--i]="$index">
					  	@if(isUserBinder(item)){
							<lgb-hero-binder 
								(unlike)="unlikeBinder(item.ident)"
								[uBinder]="item"
								[binder]="getBinder(item)"
								route="collect-binder"
								[routeParams]="[item.ident]"
							></lgb-hero-binder>
					  	}
					  	@if(isPage(item)){
					  		<div class="item-container w-64">
								<lgb-page-item 
									(unlike)="unlikePage(item.ident)"
									[page]="item"
									[scan]="getScan(item.scan)"
									[lazy]="i>10"
									[canFull]="false"
								></lgb-page-item>
							</div>
					  	}
					  	@if(isCardBinder(item)){
					  		<div class="item-container w-64">
								<lgb-card-item 
									(unlike)="unlikeCard(item.ident)"
									[backHisto]="true"
									[card]="item"
									[reference]="getRefence(item.card)"
									[scan]="getScan(item.scan)"
									[lazy]="i>10"
									[infos]="false"
								></lgb-card-item>
							</div>
					  	}
					  </div>
				  }
				</div>
			</div>
		}
		@else{
			<div class="favoris-container">
			  @for(item of favoris(); track item; let i=$index){
				  <div class="element-show fav-item mb-2" [style.--i]="$index">
				  	@if(isUserBinder(item)){
						<lgb-hero-binder 
							(unlike)="unlikeBinder(item.ident)"
							[uBinder]="item" [binder]="getBinder(item)"
							route="collect-binder"
							[routeParams]="[item.ident]"
							[fullWidth]="true"
							[cardDisplay]="true"
						></lgb-hero-binder>
				  	}
				  	@if(isPage(item)){
						<lgb-page-item 
							(unlike)="unlikePage(item.ident)"
							[page]="item" [scan]="getScan(item.scan)"
							[lazy]="i>10"
							[canFull]="false"
						></lgb-page-item>
				  	}
				  	@if(isCardBinder(item)){
						<lgb-card-item 
							(unlike)="unlikeCard(item.ident)"
							[backHisto]="true"
							[card]="item"
							[reference]="getRefence(item.card)"
							[scan]="getScan(item.scan)"
							[lazy]="i>10"
							[infos]="false"
						></lgb-card-item>
				  	}
				  </div>
			  }
			</div>
		}
	}
	@else{
		<img src="img/skin/empty-favorite.svg"/>
		<div class="empty-container">
			<p class="subtitle">
				Aucun favori pour le moment.<br/>
				Ajoute des cartes à tes favoris pour les retrouver ici.
			</p>
		</div>
	}
</div>